/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {PointDtoModel} from "@well/address-management-domain-model";

export class DelAddressTemplateDTO extends JSONable {
  uuid: string | undefined | null = undefined;
  addressLine: string | undefined = undefined;
  city: string | undefined | null = undefined;
  state: string | undefined | null = undefined;
  postalCode: string | undefined | null = undefined;
  block: string | null = null;
  building: string | null = null;
  floor: string | null = null;
  apartment: string | null = null;
  country: string | undefined | null = undefined;
  owner: string | undefined = undefined;
  pointDTO: PointDtoModel | undefined = undefined;
  visibilityType: string | undefined | null = undefined;
  addressLabel: string | undefined | null = undefined;
}
